export default {
    name: "collage"
}
